import { Box, Typography } from "@mui/material";

const NewBadge = ({ text = "New" }) => {
  return (
    <Box
      sx={{
        position: "absolute",
        top: 12,
        right: 13,
        backgroundColor: "#F7C21B", // yellow
        color: "#6A2C3E",          // purple text
        px: "4px",
        py: "7px",
        borderRadius: "14px",
        fontWeight: 700,
        fontSize: 12,
        lineHeight: 1,
        zIndex: 10,

        // 🔻 arrow
        "&::after": {
          content: '""',
          position: "absolute",
          bottom: -8,
          left: "2px",
          width: 0,
          height: 0,
          borderLeft: "0px solid transparent",
          borderRight: "14px solid transparent",
          borderTop: "10px solid #F7C21B"
        }
      }}
    >
      <Typography
        sx={{
          fontWeight: 800,
          fontSize: 12,
          lineHeight: "0px"
        }}
      >
        {text}
      </Typography>
    </Box>
  );
};

export default NewBadge;
